import * as Sentry from '@sentry/react';
import { useEffect } from 'react';
import { useRouteError } from 'react-router-dom';
import ErrorPage from '../components/ErrorPage';
import { MigrationSwitch } from '../components/MigrationSwitch';
import { MSR3_HOME_FLAGS } from '../constant/featureFlags';
import DashboardLayout from '../layout/DashboardLayout';
import { MSR3BaseLayout } from '../layout/MSR3BaseLayout';
import { userService } from '../reducers/permissions/userSlice';
import { useTypedSelector } from '../stateStore';

/**
 * Root route boundary. It can fire from any route, so it follows the same
 * flags as `/` rather than whichever page threw.
 */
export const RootErrorElement = () => {
  const error = useRouteError();
  const isAuthenticated = useTypedSelector(
    userService.selectors.isAuthenticated,
  );

  // Nothing else reports an error caught here, so without this it never
  // reaches Sentry.
  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  const page = <ErrorPage genericError />;

  return (
    <MigrationSwitch
      featureFlags={MSR3_HOME_FLAGS}
      loadingFallback={page}
      newComponent={
        // The MSR3 shell may be what threw. Rendering it again would throw
        // with no boundary left above, so fall back to the bare page. Signed
        // out, the shell's workspace queries have no token, so skip it.
        <Sentry.ErrorBoundary fallback={page}>
          {isAuthenticated ? <MSR3BaseLayout>{page}</MSR3BaseLayout> : page}
        </Sentry.ErrorBoundary>
      }
      oldComponent={<DashboardLayout>{page}</DashboardLayout>}
    />
  );
};
